import { Button } from "primereact/button";

import { buttonNext, formRegisterAnagrafica } from "../../_constants";

export const RegisterBtn = () => {
  return (
    <div className="flex-container justify-end">
      <Button
        label={buttonNext}
        type="submit"
        form={formRegisterAnagrafica}
        className="container-button"
      ></Button>
    </div>
  );
};
